var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#training-outline_svg__clip0_257_3245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0a1 1 0 011 1v2h18V1a1 1 0 112 0v2a1 1 0 110 2v2a1 1 0 11-2 0V5H3v2a1 1 0 01-2 0V5a1 1 0 010-2V1a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.936 6.649a1 1 0 00-1.872.702L7 15.181V23a1 1 0 102 0v-7h6v7a1 1 0 102 0v-7.819l2.936-7.83a1 1 0 00-1.872-.702L15.307 14H8.693L5.936 6.649z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM12 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "training-outline_svg__clip0_257_3245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTrainingOutline;